import React, { useEffect, useState, useMemo, useRef } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import moment from 'moment'
import YouTube from 'react-youtube'
import { useDropzone } from 'react-dropzone'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import Editor from 'ckeditor5-custom-build/build/ckeditor'

import { useBaseContext } from 'context/base'
import TemplateAdmin from 'component/admin/TemplateAdmin'
import { Container, Header } from 'component/template'
import InvalidText from 'component/invalid/text'
import { editorConfiguration } from 'util/ckeditor-config'
import { getBase64 } from 'util/base64'
import {
  baseStyle,
  activeStyle,
  acceptStyle,
  rejectStyle,
  thumbsContainer,
  thumb,
  thumbInner,
  img,
} from './dropzone-css'
import OverviewContentsCreator from './overview-contents-creator'
import DataTableGroupInstructor from 'component/group-teacher/datatable-group-instructor'

export default function KelasAdd() {
  /* =========================================== Refs =========================================== */
  const showUnitRef = useRef()

  /* ========================================== Helpers ========================================= */
  const history = useHistory()
  const location = useLocation()

  /* ====================================== Consume Context ===================================== */
  const { getRequest, postRequest } = useBaseContext()

  /* ======================================= Local States ======================================= */
  const [files, setFiles]                  = useState([])
  const [allCategories, setAllCategories]  = useState([])
  const [allIdClass, setAllIdClass]        = useState([])
  const [youtube, setYoutube]              = useState('')
  const [previewYutube, setPreviewYoutube] = useState('')
  const [internal, setVideo]               = useState(null)
  const [dateNow, setDateNow]              = useState()

  //================ STATE FORMS ===================
  const [name, setName]                 = useState('')
  const [description, setDesc]          = useState('')
  const [publicStatus, setStatus]       = useState('true')
  const [image, setImage]               = useState(null)
  const [categoryId, setCategory]       = useState('')
  const [categoryName, setCategoryName] = useState('')
  const [prices, setPrices]             = useState('')
  const [postVideo, setPostVideo]       = useState(null)
  const [prerequisite, setPrerequisite] = useState('')
  const [preClassId, setPreClass]       = useState('')
  const [preClassName, setPreClassName] = useState('')
  const [displayAt, setDisplayAt]       = useState('')
  const [showUnit, setShowUnit]         = useState('')
  const [showUnitName, setShowUnitName] = useState('')

  const [forceCreateDeleteGroupInstructorState, setForceCreateDeleteGroupInstructorState] = useState([])

  //============== STATE VALIDATION =================
  const [isValidName, setIsValidName]                 = useState(false)
  const [isValidDesc, setIsValidDesc]                 = useState(false)
  const [isValidCategory, setIsValidCategory]         = useState(false)
  const [isImageTooLarge, setImageTooLarge]           = useState(false)
  const [isValidShowUnit, setIsValidShowUnit]         = useState(false)
  const [widthProgress, setwidthProgress]             = useState('32')
  const [isRequired, setIsRequired]                   = useState(false)
  const [disableButtonSubmit, setdisableButtonSubmit] = useState(true)

  const [selected, setSelected] = useState('')

  /* ========================================= Constants ======================================== */
  const links = [{ url: '/kelas', name: 'Sub Mata Pelajaran' }]

  /* ======================================== Components ======================================== */
  function Dropzone() {
    const {
      getRootProps,
      getInputProps,
      isDragActive,
      isDragAccept,
      isDragReject,
    } = useDropzone({
      accept: 'image/*',
      maxSize: 1000000,
      multiple: false,
      onDrop: (acceptedFiles, fileRejections) => {
        if (acceptedFiles.length > 0) {
          setImageTooLarge(false)
          setFiles(
            acceptedFiles.map((file) =>
              Object.assign(file, {
                preview: URL.createObjectURL(file),
              }),
            ),
          )
          getBase64(acceptedFiles[0])
            .then((result) => {
              let avatarClass = result.split(',')
              setImage({ name: acceptedFiles[0].name, data: avatarClass[1] })
            })
            .catch((err) => {
              console.error(err)
            })
        }
        if (fileRejections.length > 0) {
          setImageTooLarge(true)
        }
      },
    })

    const style = useMemo(
      () => ({
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {}),
      }),
      [isDragActive, isDragReject, isDragAccept],
    )

    const Thumbs = () => {
      return (
        <div style={thumb}>
          <div style={thumbInner}>
            {image && (
              <img
                src={`data:image/jpeg;base64,${image.data}`}
                alt="preview"
                style={img}
              />
            )}
          </div>
        </div>
      )
    }

    useEffect(
      () => () => {
        // Make sure to revoke the data uris to avoid memory leaks
        files.forEach((file) => URL.revokeObjectURL(file.preview))
      },
      [files],
    )

    return (
      <>
        <label
          htmlFor="avatar-kelas"
          className="col-sm-3 col-form-label"
        >
          Upload gambar
        </label>
        <div className="col-sm-9">
          <div
            className="border rounded alert alert-warning w-100"
            role="alert"
          >
            <p className="m-0">
              <i className="fas fa-info-circle mr-1" />
              Ukuran gambar maksimal 1MB
            </p>
          </div>
          <div {...getRootProps({ style })}>
            <input {...getInputProps()} />
            <p className="mt-5">Drag or click to select file for add avatar</p>
          </div>
          <aside style={thumbsContainer}>
            <Thumbs />
          </aside>
        </div>
      </>
    )
  }

  /* ========================================= Functions ======================================== */
  function isAdmin() {
    return JSON.parse(localStorage.getItem('role_active'))
    ?.role_type === 'administrator' ||
    JSON.parse(localStorage.getItem('role_active'))
      ?.role_type === 'adminprofile'
  }

  const changeHandler = (e) => {
    setSelected(e.target.value)
  }

  async function getCategories() {
    try {
      const { data } = await getRequest('categories')
      let arr = []
      data.map((x) => {
        arr.push({
          id: x.id,
          title: x.title,
        })
      })
      setAllCategories(arr)
    } catch (error) {
      console.error(error)
    }
  }

  async function getAllIdClass() {
    try {
      const { data } = await getRequest(
        'classes?role_type=administrator',
      )
      let arr = []
      data.map((kelas) => {
        arr.push({
          id: kelas.id,
          title: kelas.title,
        })
      })
      setAllIdClass(arr)
    } catch (error) {
      console.error(error)
    }
  }

  function getVideo(item) {
    if (typeof item === 'string') {
      let preview = item.split('=')
      setPreviewYoutube(preview[1]) //untuk preview video yutube
      setYoutube(item) //untuk nama di form video yutube
      setPostVideo({ name: null, data: item, source: 'youtube' }) //untuk post ke api
      setVideo(null) //untuk menghapus data video internal yang lama
    } else if (`${typeof item}` === 'object') {
      getBase64(item)
        .then((result) => {
          let interVideo = result.split(',')
          setVideo({ name: item.name, data: result })
          setPostVideo({
            name: item.name,
            data: interVideo[1],
            source: 'internal',
          })
          setYoutube('')
        })
        .catch((err) => {
          console.error(err)
        })
    } else {
      setPostVideo(null)
    }
  }

  // validationShowUnit
  function handleValidShowUnit() {
    if (showUnit) {
      setIsValidShowUnit(false)
      document.getElementById('preview-kelas').click()
    } else {
      setIsValidShowUnit(true)
      window.notification('Mohon', 'lengkapi data', 'warning')
    }
  }

  function hendleValidation() {
    if (name && description && publicStatus && categoryId) {
      setIsValidName(false)
      setIsValidDesc(false)
      setIsValidCategory(false)
      setwidthProgress('65')
      setIsRequired(false)
      document.getElementById('detail-kelas').click()
    } else {
      if (!name) {
        setIsValidName(true)
      }
      if (!description) {
        setIsValidDesc(true)
      }
      if (!categoryId) {
        setIsValidCategory(true)
      }
      setIsRequired(true)
      window.notification('Mohon', 'lengkapi data', 'warning')
    }
  }

  function handleformsOptional() {
    if (name && description && publicStatus && categoryId) {
      setwidthProgress('100')
      setdisableButtonSubmit(false)
    } else {
      window.notification('Mohon', 'lengkapi data', 'warning')
    }
  }

  async function handleSubmitData() {
    let form = new FormData()
    form.append('title', name)
    form.append('description', description)
    form.append('public_status', JSON.parse(publicStatus))
    form.append('category_id', categoryId)
    form.append('prices', prices ? parseInt(prices) : 0)
    form.append('prerequisite', prerequisite)
    form.append('preclass_id', preClassId)
    form.append('display_at', displayAt)
    form.append('show_units', showUnit)

    if (Array.isArray(forceCreateDeleteGroupInstructorState) && forceCreateDeleteGroupInstructorState.length) {
      forceCreateDeleteGroupInstructorState.forEach((forceCreateDeleteGroupInstructorStateItem, index) => {
        if (forceCreateDeleteGroupInstructorStateItem?.id) {
          form.append(`group_teacher_id[${index}]`, forceCreateDeleteGroupInstructorStateItem.id)
        }
      })
    }

    if (image) {
      form.append('img', JSON.stringify(image))
    }
    if (postVideo !== null) {
      form.append('intro_video', JSON.stringify(postVideo))
    }

    form.append('active', JSON.parse(publicStatus))
    const response = await postRequest('classes', form)
    if (response) {
      window.notification('Sub Mata Pelajaran', 'berhasil dibuat', 'success')
      history.push('/kelas')
    } else {
      console.error('ERROR', response)
      window.notification(
        'Terjadi kesalahan',
        'Coba beberapa saat lagi',
        'error',
      )
    }
  }

  function setInnerHtml() {
    return {
      __html: prerequisite ? prerequisite : '<p>Content tidak ditemukan</p>',
    }
  }

  function getDateNow() {
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0') //January is 0!
    var yyyy = today.getFullYear()

    today = `${yyyy}-${mm}-${dd}`
    setDateNow(today)
  }

  function setDataFromLocationState() {
    if (location.state !== undefined) {
      setCategory(location.state.category.id)
      setCategoryName(location.state.category.title)
    }
  }

  /* ========================================== Effects ========================================= */
  useEffect(() => {
    getCategories()
    getAllIdClass()
    getDateNow()
    setDataFromLocationState()
  }, [])

  /* ========================================== Output ========================================== */
  return (
    <TemplateAdmin>
      <Container>
        <Header
          pageName="Tambah Sub Mata Pelajaran"
          links={links}
        />

        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5>Informasi Sub Mata Pelajaran</h5>
              </div>
              <div className="card-body p-4">
                <div className="bt-wizard">
                  <ul className="nav nav-pills nav-fill mb-3">
                    <li className="nav-item">
                      <a
                        id="data-kelas"
                        href="#progress-t-tab1"
                        className="nav-link active"
                        data-toggle="tab"
                      >
                        <span className={isRequired ? 'text-danger' : ''}>
                          Data Sub Mata Pelajaran
                        </span>
                        {isRequired && <i className="text-danger">*</i>}
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        id="detail-kelas"
                        onClick={() => {
                          hendleValidation()
                        }}
                        href="#progress-t-tab2"
                        className="nav-link"
                        data-toggle="tab"
                      >
                        <span className={isValidShowUnit ? 'text-danger' : ''}>
                          Detail Sub Mata Pelajaran
                        </span>
                        {isValidShowUnit && <i className="text-danger">*</i>}
                      </a>
                    </li>
                    {
                      isAdmin()
                        ?
                        <li className="nav-item">
                          <a
                            id="preview-kelas"
                            onClick={() => {
                              handleformsOptional()
                              handleValidShowUnit()
                            }}
                            href="#progress-t-tab3"
                            className="nav-link"
                            data-toggle="tab"
                          >
                            Guru
                          </a>
                        </li>
                        : null
                    }
                    <li className="nav-item">
                      <a
                        id="preview-kelas"
                        onClick={() => {
                          handleformsOptional()
                          handleValidShowUnit()
                        }}
                        href="#progress-t-tab4"
                        className="nav-link"
                        data-toggle="tab"
                      >
                        Pratinjau Sub Mata Pelajaran
                      </a>
                    </li>
                  </ul>
                  <div
                    className="bt-wizard progress mb-3"
                    style={{ height: '6px' }}
                  >
                    <div
                      className="progress-bar bg-success"
                      role="progressbar"
                      aria-valuenow={0}
                      aria-valuemin={0}
                      aria-valuemax={100}
                      style={{ width: `${widthProgress}%` }}
                    />
                  </div>

                  <div className="tab-content">
                    <div
                      className="tab-pane active show"
                      id="progress-t-tab1"
                    >
                      <form className="ml-1 mr-2">
                        <div className="form-group row">
                          <label
                            htmlFor="nama-kelas"
                            className="col-sm-3 col-form-label"
                          >
                            <span className="mr-1">Nama</span>
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9">
                            <input
                              value={name}
                              onChange={(val) => setName(val.target.value)}
                              className={`form-control ${
                                isValidName ? 'is-invalid' : ''
                              }`}
                              type="text"
                              id="nama-kelas"
                              placeholder="Masukan nama Sub mata pelajaran"
                            />
                            {isValidName ? (
                              <InvalidText name={'Nama Sub Mata Pelajaran'} />
                            ) : null}
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="kategori-kelas"
                            className="col-sm-3 col-form-label"
                          >
                            <span className="mr-1">Mata Pelajaran</span>
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9">
                            <select
                              value={categoryId}
                              onChange={(event) => {
                                setCategory(event.target.value)
                                setCategoryName(
                                  event.target.options[
                                    event.target.selectedIndex
                                  ].text,
                                )
                              }}
                              className={`form-control ${
                                isValidCategory ? 'is-invalid' : ''
                              }`}
                              id="kategori-kelas"
                            >
                              <option value={''}>
                                Pilih Mata Pelajaran ...
                              </option>
                              {allCategories.map((parent, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={parent.id}
                                  >
                                    {parent.title}
                                  </option>
                                )
                              })}
                            </select>
                            {isValidCategory ? (
                              <InvalidText name={'Mata Pelajaran'} />
                            ) : null}
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="deskripsi-kelas"
                            className="col-sm-3 col-form-label"
                          >
                            <span className="mr-1">Deskripsi</span>
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-sm-9">
                            <textarea
                              id="deskripsi-kelas"
                              value={description}
                              onChange={(val) => setDesc(val.target.value)}
                              rows={3}
                              className={`form-control ${
                                isValidDesc ? 'is-invalid' : ''
                              }`}
                              placeholder="Masukan deskripsi sub mata pelajaran"
                            />
                            {isValidDesc ? (
                              <InvalidText name={'Deskripsi Mata Pelajaran'} />
                            ) : null}
                          </div>
                        </div>
                        <fieldset className="form-group mb-3">
                          <div className="row">
                            <label className="col-sm-3 col-form-label">
                              Status
                            </label>
                            <div className="col-sm-9">
                              <div className="custom-control custom-radio">
                                <input
                                  onChange={(val) =>
                                    setStatus(val.target.value)
                                  }
                                  type="radio"
                                  className="custom-control-input"
                                  id="customControlValidation2"
                                  name="active"
                                  defaultValue="true"
                                  defaultChecked={true}
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customControlValidation2"
                                >
                                  Aktif
                                </label>
                              </div>
                              <div className="custom-control custom-radio mb-3">
                                <input
                                  onChange={(val) =>
                                    setStatus(val.target.value)
                                  }
                                  type="radio"
                                  className="custom-control-input"
                                  id="customControlValidation3"
                                  name="active"
                                  defaultValue="false"
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="customControlValidation3"
                                >
                                  Tidak Aktif
                                </label>
                              </div>
                            </div>
                          </div>
                        </fieldset>

                        <div className="form-group row">
                          <Dropzone />
                          {isImageTooLarge ? (
                            <span className="col offset-md-3 small form-text text-danger">
                              Ukuran gambar maksimal 1MB
                            </span>
                          ) : null}
                        </div>
                      </form>
                      <div className="form-group mb-5">
                        <label className="text-muted">Keterangan:</label>
                        <div
                          className="ml-2"
                          style={{ lineHeight: '0' }}
                        >
                          <span className="text-danger mr-1">*</span>
                          <label className="text-muted">Wajib diisi</label>
                        </div>
                      </div>
                      <div className="row btn-page ml-1 mr-2">
                        <div className="col text-right">
                          <button
                            onClick={() => {
                              hendleValidation()
                            }}
                            className="btn btn-primary button-next"
                          >
                            Lanjut
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* OPTIONAL DATA */}
                    <div
                      className="tab-pane"
                      id="progress-t-tab2"
                    >
                      <form>
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Video intro
                          </label>
                          <div className="col-sm-9">
                            <ul
                              style={{ background: 'none' }}
                              className="nav nav-pills mb-3"
                              id="pills-tab"
                              role="tablist"
                            >
                              <li className="nav-item">
                                <a
                                  className="nav-link active"
                                  id="pills-video-tab"
                                  data-toggle="pill"
                                  href="#pills-video"
                                  role="tab"
                                  aria-controls="pills-video"
                                  aria-selected="false"
                                >
                                  Use video
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  id="pills-youtube-tab"
                                  data-toggle="pill"
                                  href="#pills-youtube"
                                  role="tab"
                                  aria-controls="pills-youtube"
                                  aria-selected="true"
                                >
                                  Use Youtube
                                </a>
                              </li>
                            </ul>
                            <div
                              className="tab-content"
                              id="pills-tabContent"
                            >
                              <div
                                className="tab-pane fade show active mb-3"
                                id="pills-video"
                                role="tabpanel"
                                aria-labelledby="pills-video-tab"
                              >
                                <div className="custom-file">
                                  <input
                                    accept=".mp4"
                                    onChange={(val) =>
                                      getVideo(val.target.files[0])
                                    }
                                    type="file"
                                    className="custom-file-input"
                                    id="validatedCustomFile"
                                    required
                                  />
                                  <label
                                    className="custom-file-label"
                                    htmlFor="validatedCustomFile"
                                  >
                                    {internal
                                      ? internal.name
                                      : 'Choose video...'}
                                  </label>
                                </div>
                              </div>
                              <div
                                className="tab-pane fade"
                                id="pills-youtube"
                                role="tabpanel"
                                aria-labelledby="pills-youtube-tab"
                              >
                                <input
                                  value={youtube}
                                  onChange={(val) => getVideo(val.target.value)}
                                  type="text"
                                  id="intro-video"
                                  className={`form-control mb-3`}
                                  placeholder="https://www.youtube.com/watch?v=xyz"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Prasyarat
                          </label>
                          <div className="col-sm-9">
                            <CKEditor
                              editor={Editor}
                              data={prerequisite}
                              config={editorConfiguration}
                              onChange={(_, editor) => {
                                const data = editor.getData()
                                setPrerequisite(data)
                              }}
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="preclassId"
                            className="col-sm-3 col-form-label"
                          >
                            Sub Mapel Prasyarat
                          </label>
                          <div className="col-sm-9">
                            <select
                              id="preclassId"
                              value={preClassId}
                              onChange={(event) => {
                                setPreClass(event.target.value)
                                setPreClassName(
                                  event.target.options[
                                    event.target.selectedIndex
                                  ].text,
                                )
                              }}
                              className="form-control mb-3"
                            >
                              <option value="0">
                                Pilih Sub Mata Pelajaran ...
                              </option>
                              {allIdClass.map((item, index) => {
                                return (
                                  <option
                                    key={index}
                                    value={item.id}
                                  >
                                    {item.title}
                                  </option>
                                )
                              })}
                            </select>
                          </div>
                        </div>
                        <div className="form-group row">
                          <label
                            htmlFor="displayAt"
                            className="col-sm-3 col-form-label"
                          >
                            Tanggal tampil
                          </label>
                          <div className="col-sm-9">
                            <input
                              id="displayAt"
                              min={dateNow ? dateNow : null}
                              value={displayAt}
                              onChange={(val) => setDisplayAt(val.target.value)}
                              type="date"
                              className="form-control"
                            />
                          </div>
                        </div>
                        {/* Rules */}
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">
                            Menampilkan materi
                            <span className="text-danger"> *</span>
                          </label>
                          <div className="col-sm-9">
                            <select
                              ref={showUnitRef}
                              value={showUnit}
                              onChange={(e) => {
                                setShowUnit(e.target.value)
                                setShowUnitName(
                                  e.target.options[e.target.selectedIndex].text,
                                )
                              }}
                              className={`form-control ${
                                isValidShowUnit ? 'is-invalid' : ''
                              }`}
                            >
                              <option value="">Pilih</option>
                              <option value="any_order">Tampilkan semua</option>
                              <option value="sequential_order">
                                Tampilkan secara berurutan
                              </option>
                            </select>
                            {isValidShowUnit ? (
                              <InvalidText name={'Menampilkan Materi'} />
                            ) : null}
                          </div>
                        </div>
                      </form>
                      <br />
                      <div className="row justify-content-between btn-page ml-1 mr-2">
                        <button
                          onClick={() => {
                            document.getElementById('data-kelas').click()
                          }}
                          className="btn btn-primary button-previous"
                        >
                          Sebelumnya
                        </button>
                        <button
                          onClick={() => {
                            handleValidShowUnit()
                          }}
                          className="btn btn-primary button-next"
                        >
                          Lanjut
                        </button>
                      </div>
                    </div>

                    {/* Tab Guru */}
                    <div
                      className="tab-pane"
                      id="progress-t-tab3"
                    >
                      <OverviewContentsCreator
                      forceCreateDeleteGroupInstructorState={forceCreateDeleteGroupInstructorState}
                      setForceCreateDeleteGroupInstructorState={setForceCreateDeleteGroupInstructorState}
                      forceShowCreateDeleteGroupInstructor={true} />
                    </div>

                    {/* PREVIEW DATA */}
                    <div
                      className="tab-pane"
                      id="progress-t-tab4"
                    >
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Nama Sub Mata Pelajaran
                        </label>
                        <div className="col-sm-9">
                          <input
                            value={name ? name : '-'}
                            type="text"
                            className="form-control p-2"
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Mata Pelajaran
                        </label>
                        <div className="col-sm-9">
                          <input
                            value={categoryName ? categoryName : '-'}
                            type="text"
                            className="form-control p-2"
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Deskripsi
                        </label>
                        <div className="col-sm-9">
                          <textarea
                            value={description ? description : '-'}
                            rows={3}
                            className="form-control p-2"
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Status Sub Mata Pelajaran
                        </label>
                        <div className="col-sm-9">
                          <div className="custom-control custom-radio">
                            <input
                              type="radio"
                              className="custom-control-input"
                              id="status-review-active"
                              name="active-review"
                              defaultValue="true"
                              checked={publicStatus == 'true'}
                              readOnly
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="status-review-active"
                            >
                              Aktif
                            </label>
                          </div>
                          <div className="custom-control custom-radio mb-3">
                            <input
                              type="radio"
                              className="custom-control-input"
                              id="status-review-no-active"
                              name="active-review"
                              defaultValue="false"
                              checked={publicStatus == 'false'}
                              readOnly
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="status-review-no-active"
                            >
                              Tidak Aktif
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Avatar Sub Mata Pelajaran
                        </label>
                        <div className="col-sm-9">
                          {image ? (
                            <div style={thumb}>
                              <div style={thumbInner}>
                                <img
                                  src={`data:image/jpeg;base64,${image.data}`}
                                  alt="avatar Mata Pelajaran"
                                  style={img}
                                />
                              </div>
                            </div>
                          ) : (
                            <i className="fas fa-minus-circle fa-2x mt-2 text-danger"></i>
                          )}
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Video intro
                        </label>
                        <div className="col-sm-9">
                          {postVideo ? (
                            postVideo.source == 'youtube' ? (
                              <YouTube
                                opts={{
                                  width: '330px',
                                  height: '200px',
                                }}
                                videoId={previewYutube}
                              />
                            ) : (
                              <video
                                key={internal.data}
                                width="300px"
                                height="200px"
                                controls
                                controlsList="nodownload"
                              >
                                <source
                                  src={internal.data}
                                  type="video/mp4"
                                />
                                Your browser does not support the video tag.
                              </video>
                            )
                          ) : (
                            <i className="fas fa-minus-circle fa-2x mt-2 text-danger"></i>
                          )}
                        </div>
                      </div>
                      {
                        isAdmin()
                          ?
                          <div className="form-group row">
                            <label className="col-sm-3 col-form-label">
                              Guru
                            </label>
                            <div className="col-sm-9">
                              <button
                                type="button"
                                data-toggle="modal"
                                data-target="#showGroupGuru"
                                className={`${
                                  forceCreateDeleteGroupInstructorState?.length ? '' : 'btn-forbidden'
                                } btn btn-info`}
                                disabled={!forceCreateDeleteGroupInstructorState?.length}
                              >
                                <i className="fas fa-eye fa-lg mr-1 mt-1" />
                                <span>Tampilkan Group Guru</span>
                              </button>
                            </div>
                          </div>
                          : null
                      }
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Prasyarat
                        </label>
                        <div className="col-sm-9">
                          <button
                            type="button"
                            data-toggle="modal"
                            data-target="#showPrasyarat"
                            className={`${
                              prerequisite ? '' : 'btn-forbidden'
                            } btn btn-info`}
                            disabled={!prerequisite}
                          >
                            <i className="fas fa-eye fa-lg mr-1 mt-1" />
                            <span>Tampilkan prasyarat</span>
                          </button>
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Sub Mapel Prasyarat
                        </label>
                        <div className="col-sm-9">
                          <input
                            value={preClassName ? preClassName : '-'}
                            type="text"
                            className="form-control p-2"
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Tanggal tampil
                        </label>
                        <div className="col-sm-9">
                          <input
                            value={
                              displayAt
                                ? moment(displayAt).format('DD MMMM YYYY')
                                : '-'
                            }
                            type="text"
                            className="form-control p-2"
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="form-group row">
                        <label className="col-sm-3 col-form-label">
                          Menampilkan Materi
                        </label>
                        <div className="col-sm-9">
                          <input
                            value={showUnitName ? showUnitName : '-'}
                            type="text"
                            className="form-control p-2"
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="row btn-page mt-5">
                        <div className="col text-right">
                          <button
                            type="button"
                            onClick={() => handleSubmitData()}
                            style={{
                              cursor: disableButtonSubmit
                                ? 'not-allowed'
                                : 'pointer',
                            }}
                            className="btn btn-success"
                            disabled={disableButtonSubmit}
                          >
                            Simpan
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- Modal Group Guru --> */}
        {isAdmin()
        ?
          <div
            className="modal fade"
            id="showGroupGuru"
            data-backdrop="static"
            data-keyboard="false"
            tabIndex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body">
                  <DataTableGroupInstructor
                    showForceCreateDeleteGroupInstructorStateData={true}
                    forceCreateDeleteGroupInstructorState={forceCreateDeleteGroupInstructorState}
                    actions={['addDeleteEntry']}
                    withHeader={false}
                    forceShowCreateDeleteGroupInstructor={true}
                    setForceCreateDeleteGroupInstructorState={setForceCreateDeleteGroupInstructorState}
                  />
                </div>
                <div className="modal-footer p-2">
                  <button
                    type="button"
                    className="btn btn-danger"
                    data-dismiss="modal"
                  >
                    Tutup
                  </button>
                </div>
              </div>
            </div>
          </div>
        : null }

        {/* <!-- Modal Prasyarat --> */}
        <div
          className="modal fade"
          id="showPrasyarat"
          data-backdrop="static"
          data-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div
                  className="my-3"
                  dangerouslySetInnerHTML={setInnerHtml()}
                  style={{ overflow: 'hidden' }}
                />
              </div>
              <div className="modal-footer p-2">
                <button
                  type="button"
                  className="btn btn-danger"
                  data-dismiss="modal"
                >
                  Tutup
                </button>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </TemplateAdmin>
  )
}
